import {
    apiRequest,
    skillcertificationListAdmin,
    skillcertificationList,
    skillcertificationActive,
    skillcertificationInactive
} from "../../../../../../services/adapters/kepegawaian/skillcertificationService"

class DataTableRepository {

    fetchRowTableAdmin = async (query, cancelToken) => {
        return await apiRequest("get", skillcertificationListAdmin, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", skillcertificationList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", skillcertificationInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", skillcertificationActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository